/**
 * 應用程式進入點
 * 參考 towconnect-web 的 main.tsx
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { CssBaseline } from '@mui/material'
import './theme.css'
import { installEnvBanner } from './utils/envBanner'

// 環境標示（測試環境右上角斜帶＋分頁標題前綴；正式不顯示）
installEnvBanner()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <CssBaseline />
    <App />
  </React.StrictMode>
)
